// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__vjqOW","containerItemsCenter":"Skeleton_containerItemsCenter__1UlRZ"};